import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLBoolean
} from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'

export interface UpdateTelemetryTeamserverPreferenceMutationArgs {
  readonly input: {
    readonly enabled: boolean
  }
}

const updateTelemetryTeamserverPreferenceArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'UpdateTelemetryTeamserverPreferenceMutationArgs',
      description:
        'Mutation input type for updating telemetry teamserver preference.',
      fields: () => ({
        enabled: {
          description: 'Whether Telemetry Teamserver Preference is enabled.',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}

export const updateTelemetryTeamserverPreference: GraphQLFieldConfig<
  any,
  Context,
  UpdateTelemetryTeamserverPreferenceMutationArgs
> = {
  description: 'Update telemetry teamserver preference',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: updateTelemetryTeamserverPreferenceArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { enabled } = args.input

    await context.connector.put(`superadmin/teamserver/preference/telemetry`, {
      enabled
    })

    return {
      _placeholder: true
    }
  }
}
